import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';


export interface ComplaintUpsertState extends ApiState {
  complaintId?: string
}

export default requestReducer<ComplaintUpsertState>('COMPLAINT_UPSERT')
